/* eslint-disable tailwindcss/no-arbitrary-value */
import { TheWrapper } from '@hyphengroup/cms-components/components/TheWrapper';
import InfoCard from '../components-internal/InfoCard';
import { ComponentInfoCards } from '$/(cms)/_modules/cmsService/types';

export const InfoCards: React.FC<ComponentInfoCards> = ({ items, title }) => {
  return (
    <div className="bg-[#F5F5F5]">
      <TheWrapper type="simple">
        <div className="mx-auto max-w-screen-2xl gap-4 pt-10 2xl:gap-6">
          <h3 className="mb-4 alpha-display-2 md:text-center lg:mb-6">
            {title}
          </h3>
          <div className="mx-auto gap-4 lg:max-w-[70%]">
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:gap-6">
              {items
                ?.filter((x) => !!x)
                .map((item) => (
                  <InfoCard
                    key={item.id}
                    title={item.title ?? ''}
                    description={item.description ?? ''}
                    link={item.link ?? ''}
                    type="normal"
                  />
                ))}
            </div>
          </div>
        </div>
      </TheWrapper>
    </div>
  );
};
